export const REPORT_HEADINGS =  ['Irrelavant to topic', 'Inappropriate Content', 'Too Tough to Understand', 'Cannot access the file', 'Inadequate content', 'Other'];

